import { render } from "./VUEAppSideMenu.vue?vue&type=template&id=d46b83c8"
import script from "./VUEAppSideMenu.vue?vue&type=script&lang=js"
export * from "./VUEAppSideMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__